import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { queryService } from "../services/query-service";
import type {
  AddTryOnPhotoRequest,
  TryOnPhotosResponse,
  UpdateTryOnPhotoRequest,
} from "../models/api-types";

export const TRY_ON_PHOTOS_QUERY_KEY = ["try-on-photos"] as const;

/**
 * Try-On Fotoğrafları listesi
 * Persona ekranındaki galeri bu query'den beslenir.
 */
export const useTryOnPhotosQuery = () => {
  return useQuery({
    queryKey: TRY_ON_PHOTOS_QUERY_KEY,
    queryFn: () => queryService.getTryOnPhotos(),
    staleTime: 60 * 1000,
  });
};

/** Yeni try-on fotoğrafı yükler; backend vision doğrulamasından geçer. */
export const useAddTryOnPhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: AddTryOnPhotoRequest) =>
      queryService.addTryOnPhoto(request),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TRY_ON_PHOTOS_QUERY_KEY });
    },
  });
};

/** Fotoğrafı yeniden adlandırır veya ana fotoğraf olarak işaretler. */
export const useUpdateTryOnPhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({
      photoId,
      updates,
    }: {
      photoId: string;
      updates: UpdateTryOnPhotoRequest;
    }) => queryService.updateTryOnPhoto(photoId, updates),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: TRY_ON_PHOTOS_QUERY_KEY });
    },
  });
};

/** Fotoğrafı siler; API güncel listeyi döndürdüğü için cache'i doğrudan yazar. */
export const useDeleteTryOnPhoto = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (photoId: string) => queryService.deleteTryOnPhoto(photoId),
    onSuccess: (response) => {
      queryClient.setQueryData<TryOnPhotosResponse>(
        TRY_ON_PHOTOS_QUERY_KEY,
        response
      );
    },
  });
};
